import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';
import { Ticket } from './ticket';

@JsonObject('model.project.Project')
export class TicketsPage extends AbstractModel {

	@JsonProperty(Number, 'total')
	total?: number;

	@JsonProperty(Number, 'covered')
	covered?: number;

	@JsonProperty(String, 'user')
	user?: string;

	@JsonProperty(DateConverter, 'from')
	from?: Date;

	@JsonProperty(DateConverter, 'to')
	to?: Date;

	@JsonProperty([Ticket], 'tickets')
	tickets?: Ticket[];
}
